import React from 'react'
import backpackVerticalURL from '../../assets/images/backpack-vertical.png';
import backpackHorizontalURL from '../../assets/images/backpack-horizontal.png';
import { useInViewOnce } from '../../Utilities/Observer';

const Format = () => {
    const [ref1, visible1] = useInViewOnce();
    const [ref2, visible2] = useInViewOnce();
    const [ref3, visible3] = useInViewOnce();
    const [ref4, visible4] = useInViewOnce();
    const [ref5, visible5] = useInViewOnce();

  return (
    <section id='format' className='w-screen bg-brand-darkgray px-6 md:px-8 xl:px-[8vw] py-12 sm:py-16 md:grid grid-cols-2 md:gap-12 xl:gap-40'>
        <article>
            <article ref={ref1} className={`transition-all duration-700 ease-out ${
                visible1 ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
            }`}
>
                <p className='font-mono text-brand-blue uppercase'>// Format</p>
                <h2 className='uppercase text-brand-white font-display font-black text-4xl sm:text-[clamp(2.4rem,7vw,7.5rem)] leading-none'>
                    A clash of ideas
                </h2>
            </article>
            
            <ul className='py-8'>
                <li 
                    ref={ref2} 
                    className={`border-t border-brand-white/30 hover:border-brand-blue py-6 hover:pl-6 
                                duration-200 grid grid-cols-6 transition-all duration-700 ease-out 
                                ${visible2 ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`
                }>
                    <p className='uppercase font-mono text-brand-blue text-sm'>Team</p>

                    <div className='col-span-6 sm:col-span-5'>
                        <h4 className='text-3xl font-black font-display uppercase text-brand-white'>2–4 people</h4>
                        <p className='text-brand-white/70 font-display text-lg'>Combine technical, business and design skills.</p>
                    </div>
                </li>
                <li 
                    ref={ref3} 
                    className={`border-t border-brand-white/30 hover:border-brand-blue py-6 hover:pl-6 
                                duration-200 grid grid-cols-6 transition-all duration-700 ease-out 
                                ${visible3 ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`
                }>
                    <p className='uppercase font-mono text-brand-blue text-sm'>EVERYONE</p>

                    <div className='col-span-6 sm:col-span-5'>
                        <h4 className='text-3xl font-black font-display uppercase text-brand-white'>Every field of study</h4>
                        <p className='text-brand-white/70 font-display text-lg'>Bachelor's, master's or high school diploma: all you need is the drive to build.</p>
                    </div>
                </li>
                <li 
                    ref={ref4} 
                    className={`border-t border-brand-white/30 hover:border-brand-blue py-6 hover:pl-6 
                                duration-200 grid grid-cols-6 transition-all duration-700 ease-out 
                                ${visible4 ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`
                }>
                    <p className='uppercase font-mono text-brand-blue text-sm'>Mentor</p>

                    <div className='col-span-6 sm:col-span-5'>
                        <h4 className='text-3xl font-black font-display uppercase text-brand-white'>With Reply professionals</h4>
                        <p className='text-brand-white/70 font-display text-lg'>They guide you through development, all the way to the pitch.</p>
                    </div>
                </li>
                <li 
                    ref={ref5} 
                    className={`border-t border-brand-white/30 hover:border-brand-blue py-6 hover:pl-6 
                                duration-200 grid grid-cols-6 transition-all duration-700 ease-out 
                                ${visible5 ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`
                }>
                    <p className='uppercase font-mono text-brand-blue text-sm'>JURY</p>

                    <div className='col-span-6 sm:col-span-5'>
                        <h4 className='text-3xl font-black font-display uppercase text-brand-white'>Companies and professors</h4>
                        <p className='text-brand-white/70 font-display text-lg'>They evaluate your project together with Reply.</p>
                    </div>
                </li>
            </ul>
        </article>
        <article className='hidden md:block md:pt-40 lg:pt-20 xl:pt-32'>
            <img src={backpackVerticalURL} className='lg:aspect-[5/6] xl:aspect-[4/5] rounded-md' alt="Reply Backpack Image vertical" />
        </article>
        <article className='md:hidden'>
            <img src={backpackHorizontalURL} className='rounded-md aspect-[4/3]' alt="Reply Backpack Image horizontal" />
        </article>
    </section>
  )
}

export default Format